import ModelPrototype, { Method } from "@models/ModelPrototype";

export default class MainUser extends ModelPrototype {
  public async count(): Promise<any> {
    try {
      return this.withUrl(`main/user_count`).setMethod(Method.GET).request();
    } catch (Exception) {
      throw Exception;
    }
  }
}
